import React from 'react';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import "@fontsource/dm-serif-display"; // Defaults to weight 400
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/700.css';
import { Provider } from 'react-redux';
import './i18n';
import { store } from './state/store';
import { AuthenticationProvider } from './components/molecules/AuthenticationProvider';
import AuthenticationStateHandler from './components/organisms/AuthenticationStateHandler';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { Login } from './components/pages/Login';
import { EditCompany, IssueVc, MainLayout } from './components';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { ShowCompany } from './components/pages/ShowCompany';
import { configureAxiosDefaults } from './AxiosConfig';
import { SelectWallet } from './components/pages/SelectWallet';
import { ScanQRCode } from './components/pages/ScanQRCode';
import { CredentialsPage } from './components/pages/credentials';
import { PlaygroundPage } from './components/pages/playground';


const RedirectToPlayground = () => {
    const { search, hash } = useLocation();
    return <Navigate to={{ pathname: '/', search, hash }} replace/>;
};

// Everything behind Keycloak. /playground is public and stays outside this,
// so a visitor without an account never hits the IAM.
const ProtectedApp = () => (
    <AuthenticationProvider>
        <AuthenticationStateHandler>
            <AuthenticationStateHandler.Loading>
                <div>Loading</div>
            </AuthenticationStateHandler.Loading>
            <AuthenticationStateHandler.AuthenticationExpired>
                <div>Expired token</div>
            </AuthenticationStateHandler.AuthenticationExpired>
            <AuthenticationStateHandler.UnAuthenticated>
                <Login/>
            </AuthenticationStateHandler.UnAuthenticated>
            <AuthenticationStateHandler.Authenticated>
                <Outlet/>
            </AuthenticationStateHandler.Authenticated>
        </AuthenticationStateHandler>
    </AuthenticationProvider>
);

function App() {

    const theme = createTheme({
        palette: {
            primary: {
                light: '#757ce8',
                main: '#313A89',
                dark: '#002884',
                contrastText: '#fff',
            },
            secondary: {
                light: '#ff7961',
                main: '#f44336',
                dark: '#ba000d',
                contrastText: '#000',
            },
        },
    });

    configureAxiosDefaults(store);
    return (
        <Provider store={store}>
            <CssBaseline />
            <ThemeProvider theme={theme}>
            {/* Op de France Identité-cluster hangt de app onder /credenco/demo/ en rewrite't
                de gateway dat naar /, dus de router moet dat pad zelf terugzetten. Leeg bij
                ons: dan is de basename gewoon de root. */}
            <BrowserRouter basename={process.env.REACT_APP_BASENAME || undefined}>
                <Routes>
                    {/* The root and any unknown path land on the playground, so the public
                        host never opens on a Keycloak login. Keep this outside ProtectedApp. */}
                    <Route path="/" element={<PlaygroundPage/>}/>
                    {/* Oude deeplink; blijft werken voor wat al gedeeld is. */}
                    <Route path="/playground" element={<RedirectToPlayground/>}/>
                    <Route path="*" element={<RedirectToPlayground/>}/>
                    <Route element={<ProtectedApp/>}>
                        <Route element={<MainLayout/>}>
                            <Route path="/company" element={<ShowCompany/>}/>
                            <Route path="/issue/wallet" element={<SelectWallet/>}/>
                            <Route path="/issue/personal" element={<ScanQRCode/>}/>
                            <Route path="/issue" element={<IssueVc/>}/>
                            <Route path="/credentials" element={<CredentialsPage/>}/>
                            <Route path="/company/edit" element={<EditCompany/>}/>
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
            </ThemeProvider>
        </Provider>

    );
}

export default App;
